import React, { useState, useEffect } from "react";
import { Avatar, Select } from "antd";
import { UserOutlined, SearchOutlined, MenuOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./styles.css";

const { Option } = Select;

function Header({ onToggleMobileMenu, mobileMenuOpen }) {
  const [usuario, setUsuario] = useState({});
  const [tipoColecao, setTipoColecao] = useState("certificados");
  const [searchValue, setSearchValue] = useState("");
  const [userType, setUserType] = useState("admin");
  const navigate = useNavigate();

  useEffect(() => {
    const usuarioData = JSON.parse(sessionStorage.getItem("seepilUsuario"));
    const tipo = sessionStorage.getItem("seepilUserType");
    setUsuario(usuarioData || {});
    setUserType(tipo || "admin");

    // Cliente só pode buscar certificados
    if (tipo === "cliente") {
      setTipoColecao("certificados");
    }
  }, []);

  const handleSearchGeral = (e) => {
    e.preventDefault();
    const termo = searchValue.trim();
    if (!termo) return;

    const basePath = userType === "admin" ? "/admin" : "/cliente";

    if (tipoColecao === "valvulas") {
      navigate(`${basePath}/valvulas?search=${encodeURIComponent(termo)}`);
    } else if (tipoColecao === "certificados") {
      navigate(`${basePath}/certificados?search=${encodeURIComponent(termo)}`);
    }
  };

  const getInitials = (name) => {
    if (!name) return "U";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();
  };

  return (
    <header className="header">
      {/* Botão hambúrguer para mobile */}
      <button
        className={`mobile-menu-btn ${mobileMenuOpen ? "active" : ""}`}
        onClick={onToggleMobileMenu}
        aria-label="Menu"
      >
        <MenuOutlined />
      </button>

      {/* Logo visível no mobile (ao lado do botão hambúrguer) */}
      <div className="mobile-logo">
        <img
          src="/assets/logo-seepil.png"
          alt="Seepil Valve Care"
          className="mobile-logo-image"
        />
      </div>

      <div className="header-left">
        <form onSubmit={handleSearchGeral} className="search-box">
          {userType === "admin" ? (
            <Select
              value={tipoColecao}
              onChange={setTipoColecao}
              className="search-select"
              bordered={false}
            >
              <Option value="valvulas">Válvula</Option>
              <Option value="certificados">Certificado</Option>
            </Select>
          ) : (
            <span className="search-label">Certificado</span>
          )}
          <input
            type="text"
            placeholder={userType === "cliente" ? "SPL ou Nº do certificado..." : "Digite aqui..."}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            className="search-input"
          />
          <button type="submit" className="search-button">
            <SearchOutlined />
          </button>
        </form>
      </div>

      <div className="header-right">
        <div className="user-info">
          <Avatar
            size={44}
            src="/assets/avatar.jpg"
            icon={<UserOutlined />}
            className="user-avatar"
          >
            {getInitials(usuario.nomeUsuario)}
          </Avatar>
          <div className="user-details">
            <span className="user-name">
              {usuario.nomeUsuario || "Usuário"}
            </span>
            <span className="user-role">
              {usuario.nomeEmpresa || "Seepil"}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
